import * as yup from 'yup';

export const commonCreditChgDtlValidation: { [x: string]: any; } = {
  creditChargingQty: yup.number().required("Missing.").min(1).max(9999999999.99),
  creditAmount: yup.number().required("Missing.").min(1).max(9999999999.99),
  opsDate: yup.date().required("Missing."),
  currencyCode: yup.string().required("Missing."),
  vatPercent: yup.number()
    .transform((value, originalValue) => {
      return originalValue === null || originalValue === '' ? undefined : value;
    })
    .typeError("Must be a number")
    .test(
      "max-100",
      "Tax % should be range from 0 to 100.",
      value => value === undefined || value <= 100
    )
    .nullable(),

};

export const commonCreditChgHdrValidation: { [x: string]: any; } = {
  reqNo: yup.string().required("Missing."),
  customerCode: yup.string().required("Missing."),
};

export const createCreditChgDtlValidation: { [x: string]: any; } = {
  ...commonCreditChgDtlValidation,
};

export const createCreditChgHdrValidation: { [x: string]: any; } = {
  ...commonCreditChgHdrValidation,
};

export const createCreditChgHdrValidationSchema = yup.object().shape(createCreditChgHdrValidation);

export const createCreditChgDtlValidationSchema = yup.object().shape(createCreditChgDtlValidation);
